import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const PromotionReferralWidgetRBAC = {
  pageID: 'dd90bfaa4cb8be072040c125358924e9',
  elementID: {
    View: '1366c0e90140e70395352d7e37f9bf92',
    Submit: '54c0322278047bb3908df1a64c23d599',
  },
} as const

export const useRBACPromotionReferralWidgetPage = createUseRBAC(
  PromotionReferralWidgetRBAC.elementID,
)
export type UseRBACPromotionReferralWidgetPageType = ReturnType<
  typeof useRBACPromotionReferralWidgetPage
>
